import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from '../../shared/components/ErrorBoundary';
import { Layout } from '../Layout';
import { PackageOverview } from '../shared/packages';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../store/rootReducer';
import Discovery from './campaign/discovery/components/Discovery';
import { CampaignRoutes } from './campaign/routes';
import { SettingsRoutes } from '../shared/routes';
import { CampaignCreateRoutes } from './campaign/briefing/routes';

const BrandDashboard = lazy(() => import('./dashboard/index'));
const BrandClient = lazy(() => import('./client/components/ClientOverview'));
const BrandSupplier = lazy(() => import('./supplier/SupplierOverview'));
const BrandContracts = lazy(() => import('./contracts/index'));
const InfluencerProfile = lazy(() => import('../influencer/profile/profile-view'));
const ForbiddenPage = lazy(() => import('../../authentication/403'));
const GlobalBrandRoutes = lazy(() => import('./global/routes').then(module => ({ default: module.GlobalBrandRoutes })));

export function BrandRoutes() {
    const isGlobalBrandVisible = process.env.VITE_ENABLE_GLOBAL === 'true';
    const isGlobalBrandActive = useSelector((states: IAllStates) => states?.auth?.isGlobalBrand);
    const isShownToUser = useSelector((states: IAllStates) => states.auth.user.company?.package.isShownToUser);

    const defaultBrandRoute = isGlobalBrandActive ? '/brand/global/dashboard' : '/brand/dashboard';

    return (
        <Suspense fallback={null}>
            <ErrorBoundary>
                <Routes>
                    <Route element={<Layout />}>
                        {!isGlobalBrandActive && (
                            <>
                                <Route path="/brand/dashboard" element={<BrandDashboard />} />
                                <Route path="/brand/campaign/*" element={<CampaignRoutes />} />
                                <Route path="/brand/create/campaign/*" element={<CampaignCreateRoutes />} />

                                <Route path="/brand/influencer/profile/:id" element={<InfluencerProfile />} />
                                <Route path="/brand/discovery" element={<Discovery />} />
                            </>
                        )}
                        {isGlobalBrandVisible && isGlobalBrandActive && (
                            <Route path="/brand/global/*" element={<GlobalBrandRoutes />} />
                        )}
                        <Route path="/brand/contracts" element={<BrandContracts />} />
                        <Route path="/brand/client" element={<BrandClient />} />
                        {isShownToUser && <Route path="/brand/package-overview" element={<PackageOverview />} />}
                        <Route path="/brand/supplier" element={<BrandSupplier />} />
                        <Route path="/settings/*" element={<SettingsRoutes />} />
                        <Route path="/403" element={<ForbiddenPage />} />
                    </Route>

                    <Route path="/auth/login" element={<Navigate to={defaultBrandRoute} replace />} />
                    <Route path="/" element={<Navigate to={defaultBrandRoute} replace />} />
                    <Route path="*" element={<Navigate to={defaultBrandRoute} replace />} />
                </Routes>
            </ErrorBoundary>
        </Suspense>
    );
}
